import { useContext } from 'react';
import AppDataContext from './AppDataContext';

const useAppDataContext = () => {
  const context = useContext(AppDataContext);

  if (!context) {
    throw new Error('useAppDataContext must be used within an AppDataProvider');
  }

  return context;
};

export default useAppDataContext;
